import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Navbar({ isAdmin, onLogout }) {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);

  const navLink = (path, label) => (
    <li className="nav-item">
      <Link
        className={`nav-link ${location.pathname === path ? "active" : ""}`}
        to={path}
        onClick={() => setCollapsed(true)}
      >
        {label}
      </Link>
    </li>
  );

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light mb-4">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">Media Management</Link>

        <button
          className="navbar-toggler"
          type="button"
          aria-label="Toggle navigation"
          onClick={() => setCollapsed(!collapsed)}
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className={`navbar-collapse ${collapsed ? "collapse" : ""}`}>
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {isAdmin && navLink("/generate", "Generate")}
            {navLink("/preapprove_images", "Pre Approve Images")}
            {isAdmin && navLink("/approve_images", "Approve Images")}
            {navLink("/assign_keywords", "Assign Keywords")}
            {navLink("/", "Images")}
            {isAdmin && navLink("/metrics", "Metrics")}
            {navLink("/books_data", "Books")}
            {isAdmin && navLink("/images_metrics", "Images Metrics")}
          </ul>
          <button className="btn btn-outline-danger" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
